import { kaapApiRef, useAzureToken } from '@internal/backstage-plugin-kaap';
import { useAsync } from 'react-use';

import { useApi } from '@backstage/core-plugin-api';

export const useGetKaapClusters = () => {
  const kaapApi = useApi(kaapApiRef);
  const { getToken } = useAzureToken();

  const {
    value: clusters,
    loading,
    error,
  } = useAsync(async () => {
    const { token } = await getToken();
    return kaapApi.getClusters(token);
  }, []);

  return { value: clusters, loading, error };
};
